import { EventManager } from 'utils/event_manager';
import { handleApiError } from 'utils/api_error_handler';
import './index.scss';

export default class QuestionRepliesEditor {
  constructor(context) {
    vendorManager.ensure('quill', () => {
      this.$context = $(context);
      this.commentId = this.$context.data().commentId;
      this.segmentId = this.$context.data().segmentId;
      this.questionCommentArea = false;
      this.$sendButton = $('.js-send-comment-btn', this.$context);
      this.$editButton = $('.js-edit-replies-btn', this.$context);

      this.instantiateQuill();
      this.activateCreateMode();
    });
  }

  instantiateQuill() {
    const $editor = $(`#q-editor-reply-${this.commentId}`, this.$context);

    if (!$editor.length || $editor.hasClass('ql-container')) {
      return;
    }

    this.editor = new Quill(`#q-editor-reply-${this.commentId}`, {
      modules: {
        toolbar: [['bold', 'italic', 'underline'], [{ color: [false, 'red', 'green', 'blue'] }]]
      },
      placeholder: 'Responder...',
      theme: 'snow'
    });

    this.$questionCommentArea = $('.ql-editor', this.$context);

    this._bindSend();

    this.listenToCommentEditEvent();
  }

  _bindSend() {
    this.$sendButton.on('click', e => {
      e.preventDefault();

      if (this._validateCommentArea()) {
        EventManager.publish(`commentReply.${this.commentId}.create`, {
          commentHTML: this.$questionCommentArea.html()
        });
      }
    });
  }

  listenToCommentEditEvent() {
    EventManager.subscribe(`commentReply.${this.commentId}.populateEditor`, this.updateEditor.bind(this));

    EventManager.subscribe(`commentReply.${this.commentId}.failed`, this.updateEditor.bind(this));

    EventManager.subscribe(`commentReply.${this.commentId}.saved`, this.clearEditor.bind(this));
  }

  updateEditor(event, data) {
    this.editor.clipboard.dangerouslyPasteHTML(data.commentHTML);

    this.activateEditMode(data.replyId);
    $('html, body').animate({ scrolltop: this.$context.offset().top - 40 }, 800);
  }

  clearEditor() {
    this.editor.setText('');
  }

  activateEditMode(replyId) {
    this.$sendButton.off('click').on('click', () => {
      if (this._validateCommentArea()) {
        EventManager.publish(`commentReply.${this.commentId}.update`, {
          commentHTML: this.$questionCommentArea.html(),
          replyId
        });

        this.activateCreateMode();
        this.clearEditor();
      }
    });
  }

  activateCreateMode() {
    this.$sendButton.off('click').on('click', e => {
      e.preventDefault();

      if (this._validateCommentArea()) {
        EventManager.publish(`commentReply.${this.commentId}.create`, {
          commentHTML: this.$questionCommentArea.html()
        });
      }
    });
  }

  _validateCommentArea() {
    if ($.trim(this.$questionCommentArea.text()).length > 0) {
      return true;
    } else {
      toastr.warning('Seu comentário não pode ser vazio.');
      return false;
    }
  }

  static createAndRender(commentId, segmentId, commentHTML) {
    return new Promise((resolve, reject) => {
      Thor.Commentary.create_and_render(
        {
          question_id: commentId
        },
        {
          data: {
            text: commentHTML,
            resource_id: commentId,
            segment_id: segmentId,
            source_project: 1,
            component_name: 'questions/comment_replies/item'
          }
        }
      )
        .then(html => resolve(html))
        .catch(({ response }) => {
          handleApiError('Ops! Não foi possível criar seu comentário nesse momento!', response);
          reject(response);
        });
    });
  }

  static updateAndRender(commentId, replyId, commentHTML) {
    return new Promise((resolve, reject) => {
      Thor.Commentary.update_and_render(
        {
          question_id: commentId,
          id: replyId
        },
        {
          data: {
            text: commentHTML,
            component_name: 'questions/comment_replies/item'
          }
        }
      )
        .then(html => resolve(html))
        .catch(({ response }) => {
          handleApiError('Ops! Não foi possível editar seu comentário nesse momento!', response);
          reject(response);
        });
    });
  }
}
